import Member from "../User/Member";
import React, {useState} from "react";
import MemberEdit from "../User/MemberEdit";

function ListTeamUsers(props: {
  org: any,
  team: any,
  users: any,
  permissionGuest: boolean,
  permissionAdmin: boolean,
  loadData: any
}) {
  const {org, team, users, permissionGuest, permissionAdmin, loadData} = props;
  const [showMemberEdit, setShowMemberEdit] = useState(false);
  const [user, setUser] = useState();

  const showEdit = permissionAdmin ? function (userId: string) {
    const user = users.find(function (user: any) {
      return user.id === userId;
    });

    setUser(user);
    setShowMemberEdit(true);
  } : null;

  const usersList = users.map((user: any) =>
    <Member user={user} key={user.id} showEdit={showEdit}/>) || [];

  const message = (permissionGuest ?
    "You are a Guest"
    : (permissionAdmin ?
      "You are an Admin"
      : "You are a Member"));

  const subMessage = permissionAdmin && !team.id ?
    <li>
      (Save first then add people)
    </li>
    : null;

  return (
    <>
      <ul className="pt-1">
        <li className="text-nowrap">
          <b>{message}</b><span className="px-4"/><span className="px-4"/><span className="px-4"/>
        </li>
        {subMessage}
        {usersList}
      </ul>
      <MemberEdit
        user={user}
        orgId={org.id}
        teamId={team.id}
        loadData={loadData}
        show={showMemberEdit}
        onHide={() => {
          setShowMemberEdit(false);
          loadData();
        }}
      />
    </>
  )
}

export default ListTeamUsers;
